module.exports = __webpack_public_path__ + "open-graph-8c735e6625a99c1f9d8b.png";